(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Relational', Relational);

    Relational.$inject = ['$resource'];

    function Relational ($resource) {
        var resourceUrl =  'api/relationals/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': { url: 'api/relationals/filter', method: 'GET', isArray: true }
        });
    }
})();
